import { createUniqueIdLong } from '../../../pure-js/libs/Common'

export const MOCK_PRIVATE_LESSONS_REGISTER_TOKEN = 'demo'

export type PrivateLessonsScheduledSessionMock = {
  id: string
  startIso: string
  durationMin: number
  instructorName: string
  locationName: string
  status: 'requested' | 'scheduled' | 'completed' | 'cancelled'
  notes?: string
}

export type PrivateLessonsReceiptMock = {
  receiptId: string
  createdAtIso: string
  userName: string
  userEmail: string
  clientName: string
  clientId: string
  packageName: string
  lessonCount: number
  durationMin: number
  totalPriceInCents: number
  vatPercent: number
  currency: string
  paymentMethod: 'Swish'
}

export type PrivateLessonsPortalMockData = {
  registerToken: string
  registerLink: string
  userName: string
  clientName: string
  clientURL: string
  contactEmail: string
  receipt: PrivateLessonsReceiptMock
  scheduledSessions: PrivateLessonsScheduledSessionMock[]
}

export const getMockPrivateLessonsPortalData = (registerToken: string): PrivateLessonsPortalMockData => {
  const baseUrl = 'https://app.coursely.se'
  const registerLink = `${baseUrl}/privateLessons/portal/${registerToken}`

  const receipt: PrivateLessonsReceiptMock = {
    receiptId: createUniqueIdLong(),
    createdAtIso: new Date().toISOString(),
    userName: 'Eddie Ullberg',
    userEmail: 'eddie@example.com',
    clientName: 'Coursely',
    clientId: 'demoClientId',
    packageName: '5 Private Lessons',
    lessonCount: 5,
    durationMin: 60,
    totalPriceInCents: 289000,
    vatPercent: 25,
    currency: 'SEK',
    paymentMethod: 'Swish'
  }

  const scheduledSessions: PrivateLessonsScheduledSessionMock[] = [
    {
      id: createUniqueIdLong(),
      startIso: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString(),
      durationMin: 60,
      instructorName: 'Maria Andersson',
      locationName: 'Studio 1',
      status: 'requested',
      notes: 'Bring comfortable shoes'
    },
    {
      id: createUniqueIdLong(),
      startIso: new Date(Date.now() + 9 * 24 * 60 * 60 * 1000).toISOString(),
      durationMin: 60,
      instructorName: 'Erik Johansson',
      locationName: 'Studio 2',
      status: 'scheduled'
    },
    {
      id: createUniqueIdLong(),
      startIso: new Date(Date.now() + 16 * 24 * 60 * 60 * 1000).toISOString(),
      durationMin: 90,
      instructorName: 'Sofia Lindberg',
      locationName: 'Studio 1',
      status: 'scheduled',
      notes: 'Warm-up starts 10 minutes before'
    }
  ]

  return {
    registerToken,
    registerLink,
    userName: receipt.userName,
    clientName: receipt.clientName,
    clientURL: 'https://coursely.se',
    contactEmail: 'support@coursely.se',
    receipt,
    scheduledSessions
  }
}
